<section class="welcome">
  <h2 class="title">{{ 'news.welcome.title' | customLocale }}&nbsp;
    <span class="name">{{ firstName }}</span>&nbsp;👋
  </h2>

  <span class="text">{{ 'news.welcome.text' | customLocale }}</span>
</section>
